module.exports = __webpack_public_path__ + "img/manual-grn-01-qr-code.863ebfbd.png";